import { Cell, Grid, Heading, HFlow, Icon, InfoLabel } from 'bold-ui'
import { Color } from 'csstype'
import { css } from 'emotion'
import React from 'react'

interface AcompanhamentoCondicaoSaudeMedicoesPessoaIdosaAccordionPanelProps {
  quantidadeMedicoesPesoAlturaSimultaneos: number
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeMedicoesPessoaIdosaAccordionPanel(
  props: Readonly<AcompanhamentoCondicaoSaudeMedicoesPessoaIdosaAccordionPanelProps>
) {
  const { quantidadeMedicoesPesoAlturaSimultaneos, iconColor } = props

  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline' style={styles.content}>
      <Cell size={12}>
        <HFlow hSpacing={0.25} alignItems='center'>
          <Icon icon='rulerFilled' size={1} color={iconColor} />
          <Heading level={4}>Medições (quantidade)</Heading>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <InfoLabel
          title='Registros de peso e altura simultâneos nos últimos 12 meses'
          placeholder='-'
          titleStyles={styles.title}
        >
          {quantidadeMedicoesPesoAlturaSimultaneos}
        </InfoLabel>
      </Cell>
    </Grid>
  )
}

const styles = {
  content: css`
    padding: 1rem 0;
  `,
  title: css`
    padding-bottom: 0.25rem;
  `,
}
